<template>
  <div class="h5login">
    <div class="container">
      <div class="bindPhone">{{editPhone ? '手机号修改' : '手机号绑定'}}</div>
      <div class="login">
        <p class="notLine">
          <input type="text" v-model="login.phone" placeholder="请输入手机号">
        </p>
        <p>
          <input type="text" v-model="login.code" placeholder="请输入验证码">
          <span  @click="telCode" id="sentCode" :style="{background: `${colourName}`}">获取验证码</span>
        </p>
      </div>
        <div class="h5login_footer" @click="save" :style="{background: `${colourName}`}">
          <span>{{editPhone ? '确认修改' : '立即使用'}}</span>
        </div>
    </div>
  </div>
</template>
<script defer=true>
import * as api from "@/api";
import JmmToast from '@/components/JmmToast'
export default {
  name: "wxlogin",
  data() {
    return {
      colourName: '',
      login: {
        phone:null,
        code: null,
      },
      editPhone: '',
      prohibit: true,
      token: "lmojakdhkadocfaccfjocklccdfkhgoj",
      mobile: "",
      sign: '',                 // 签名
    };  
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    // 来自个人中心的 手机号, 用来修改手机号的
    this.editPhone = this.$route.query.editPhone;
    this.sign = this.$route.query.sign
    document.title = this.editPhone ? '修改手机号': '绑定手机号'
    // 色调选择
    this.displayType = localStorage.getItem("displayType");
    if(this.displayType === '0'){
      this.colourName = "#f8992d";
    } else{
      this.colourName = "#FC4E4D";
    }
  },
  computed: {
    styleVar() {
      return {
        '--colourName': this.colourName
      }
    }
  },
  methods: {
    telCode: async function () {
      let rgh = /^[1]([3-9])[0-9]{9}$/
      if (!rgh.test(this.login.phone)) {
        return JmmToast('手机号码有误')
      }

      //防重点击
      if (!this.prohibit) {
        console.log('正在获取中，请勿重复')
        return
      }

      var i = 61
      let that = this
      let intervalID = setInterval(function() {
          i -= 1
          document.getElementById('sentCode').innerHTML = i + ' s'
          if (i == -1) {
            that.prohibit = true
            // console.log(i,'-------------', that.prohibit)
            clearInterval(intervalID)
            document.getElementById('sentCode').innerHTML = '重新获取'
            return
          }
      }, 1000)

       this.prohibit = false

      try {
   
        localStorage.setItem('reToken', this.token)
         const res = await api.user.getMsg(this.login.phone)
         if (res.code === '000000') {
           console.log(res.message, 'res')
         }
      } catch (error) {
       console.log(error)
      }
      
    },
    save: async function() {
        if (!this.login.phone) {
          return JmmToast('手机号不能为空')
        }
        
        let rgh = /^[1]([3-9])[0-9]{9}$/
        if (!rgh.test(this.login.phone)) {
          return JmmToast('手机号码有误')
        }

        if (!this.login.code) {
          return JmmToast('验证码不能为空')
        }

        // if (this.login.code !== this.telCode) {
        //   return JmmToast('验证码不正确')
        // }

        try {
        
          localStorage.setItem('reToken', this.token)
          let params = {
            "code": this.login.code,
            "mobile": this.login.phone,
            "sign": this.sign
          }
          const res = await api.user.bindPhone(params)
          // alert(JSON.stringify(res) + '绑定手机号' + JSON.stringify(params))
          if (res.code == '000000') {
            let toUrl = `info.html#/?sign=${this.sign}`
            window.location.href = toUrl

          } else {
             JmmToast(res.message)
          }
        } catch (error) {
         console.log(error)
        }
    },

  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

.h5login {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: #fff;

   display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  width: 621px;
  margin: 0px auto; 
}
.login {
  margin: 0px auto; 
  margin: 200px auto; 
  p:first-child {
    border-top: 1px solid #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;  
  }
  p:nth-child(2) {
    display: flex;
    justify-content: space-between;
    align-items: center; 
  }
  
  .notLine {
    border-top: 1px solid #fff;
  }

  p {
    border-bottom: 1px solid #d7d7d7;
    height: 120px;
    line-height :120px;
    input {
      border: none;
			outline: none;
			resize: none;
      height: 70px;

      font-size: 30px;
      font-family: Source Han Sans SC VF;
      font-weight: 400;
      line-height: 44px;
      color: #8A8A8A;
    }

    input::-ms-input-placeholder{ color: #8A8A8A; }
    input::-webkit-input-placeholder {color: #8A8A8A; } 
    span {
      opacity: 1 !important; 
      display: inline-block;
      width: 245px;
      height: 70px;
      background: #FC4E4D;
      border-radius: 35px;

      font-size: 28px;
      font-family: Source Han Sans SC VF;
      font-weight: 400;
      line-height: 70px;
      text-align: center;
      color: #FFFFFF;
    }
  }
}

.bindPhone {
  font-size: 56px;
  font-family: Source Han Sans SC VF;
  font-weight: bold;
  color: #515151;
}

.h5login_footer {
    width: 100%;
    height: 100px;
    background: #FC4E4D;
    border-radius: 50px;

    font-size: 32px;
    font-family: Source Han Sans SC VF;
    font-weight: 400;
    color: #FFFFFF;

    text-align: center;
    line-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/wxcardlogin/index.vue